<template>
    <be-form-group v-bind="widgetProps" class="range-slider">
        <div class="d-flex align-items-baseline">
            <div ref="el" class="w-50" :disabled="disabled || min === max"></div>
            <div class="w-50 px-4">{{formatter(value)}}</div>
        </div>
    </be-form-group>
</template>

<script>
    import noUiSlider from 'nouislider';
    import 'nouislider/distribute/nouislider.css';

    import widget from '../../mixins/widget';

    export default {
        mixins: [widget],

        props: {
            range: {
                type: Object,
            },
            pips: {
                type: Object,
            },
            min: {
                type: Number,
            },
            max: {
                type: Number,
            },
            step: {
                type: Number,
                default: 1,
            },
            connect: {
                type: [Array, Boolean],
            },
            formatter: {
                type: Function,
                default: value => (value instanceof Array ? value.join(', ') : value),
            },
        },

        data: () => ({
            slider: null,
            sliderValue: null,
        }),

        methods: {
            init() {
                if (!this.$refs.el || this.slider) {
                    return;
                }

                if (this.min === this.max) {
                    this.slider = noUiSlider.create(this.$refs.el, {
                        range: {
                            min: 0,
                            max: 1,
                        },
                        start: 0,
                    });
                    return;
                }

                this.slider = noUiSlider.create(this.$refs.el, this.options);

                this.slider.on('update', (value, handle) => {
                    const data = this.multiple ? this.value : [this.value];
                    const input = value.map(v => Number(v));

                    if (data[handle] !== input[handle]) {
                        data.splice(handle, 1, input[handle]);

                        this.sliderValue = this.multiple ? data : data[handle];
                        this.$emit('input', this.sliderValue);
                    }
                });
            },
        },

        computed: {
            multiple: vm => vm.value instanceof Array,

            options() {
                let { connect } = this;

                if (!connect) {
                    connect = this.multiple
                        ? [false].concat(new Array(this.value.length - 1).fill(true), [false])
                        : [true, false];
                }

                return {
                    range: this.range || {
                        min: this.min,
                        max: this.max,
                    },
                    pips: this.pips,
                    start: this.value,
                    behaviour: 'snap',
                    connect,
                    step: this.step,
                };
            },
        },

        watch: {
            value(value) {
                if (!this.slider || value === this.sliderValue) {
                    return;
                }

                this.slider.set(
                    value instanceof Array ? value.map(v => Number(v)) : Number(value),
                );
            },

            min() {
                if (!this.slider) {
                    return;
                }

                this.slider.updateOptions(this.options);
                // this.slider.destroy();
                // this.slider = null;
                // this.init();
            },

            max() {
                if (!this.slider) {
                    return;
                }

                this.slider.updateOptions(this.options);
                // this.slider.destroy();
                // this.slider = null;
                // this.init();
            },
        },

        updated() {
            this.init();
        },

        mounted() {
            this.init();
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss">
    .range-slider {

        .noUi-target {
            background: #e0e0e0;
            border: none;
            border-radius: 4px;
            box-shadow: none;
        }

        .noUi-connect {
            border-radius: 4px;
            box-shadow: none;

            @if(env('VUE_APP_ENV') == 'grf') {
                background: #FFB70F;
            } @else if(env('VUE_APP_ENV') == 'heidiland') {
                background: #F20026;
            } @else {
                background: #4285f4;
            }
        }

        .noUi-handle {
            height: 22px;
            width: 22px;
            background: #ffffff;
            border: 1px solid #f0f0f0;
            border-radius: 50%;
            box-shadow: 0 0 3px rgba(0, 0, 0, 0.12);

            &:before,
            &:after {
                content: none;
            }
        }

        .noUi-horizontal {
            height: 8px;

            .noUi-handle {
                top: -7px;
            }

            .noUi-value {
                top: 20px;
            }
        }

        .noUi-pips-horizontal {
            left: 6px;
        }

        .noUi-target[disabled] {
            .noUi-connect {
                background: #404040;
            }

            .noUi-handle {
                outline: none;
            }
        }

        &--inline {
            .noUi-target {
                margin-left: 20px;
            }
        }
    }
</style>
